const LoadingAnimation = ({ text = "Loading..." }) => {
    return (
        <div className="d-flex justify-content-center align-items-center flex-column" style={{ height: '100vh', position: 'fixed', top: 0, left: 0, width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 1000 }}>
             
                
                <div className="sk-grid sk-primary">
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                    <div className="sk-grid-cube"></div>
                </div>

                <span className="text-primary  fw-bold border border-dashed border-primary rounded-3 text-center fs-5 mt-4 p-4">
                    {text}
                </span>
            

        </div>
    );
}

export default LoadingAnimation;